export function GetPatientFormFieldKey(customerId: string, fieldId: string) {
    return `patient_form_${customerId}_${fieldId}`;
}